export default {
    routerName: '職位管理',
    post: {
        searchName: '検索条件',
        name: '職位名',
        code: '職位番号',
        sortOrder: 'ソート',
        status: '状態',
        open: '有効',
        close: '無効',
        createBy: '作成者',
        createTime: '作成日付',
        createStartTime: '作成開始日付',
        createEndTime: '作成終了日付',
    },
    table: {
        id: 'ID',
        name: '職位名',
        code: '職位番号',
        sortOrder: 'ソート',
        status: '状態',
        createBy: '作成者',
        createTime: '作成日付',
    },
};
